let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cqSzt")).then(() => parcelRequire('2YhMX'));